export const getStorage = (key) => {
    if(typeof window !== 'undefined'){
        return localStorage.getItem(key);
    }
    return null;
}

export const setStorage = (key, value) => {
    if(typeof window !== 'undefined'){
        if(!value) {
            localStorage.removeItem(key);
            return;
        }
        localStorage.setItem(key, value)
    }
}
